import BaseNode from './BaseNode';
import { getLineDirection, getSingleLineSize, getLineRenderData } from '../../utils/line';
import { fixedNumber } from '../../utils/common';
import { SHAP_TYPE } from '../../enums/index';

/**
* 线node
*/
class LineNode extends BaseNode {
  constructor(renderProps, funType, rendrenOption) {
    super(renderProps, funType, rendrenOption);
  }
  
  async init(renderProps, rendrenOption) {
    const { startX, startY, endX, endY, size, startSize = 0 } = renderProps;
    
    // 优先取服务端数据size
    const lineSize = size || getSingleLineSize(startX, startY, endX, endY);
    
    // 创建Konva实例对象
    const stateNode = new Konva.Line({
      points: [ startX, startY, endX, endY ],
      ...rendrenOption || {}
    });

    this.stateNode = stateNode; // 挂载stateNode
    this.stateNode.__node = this; // 实例对象反向记录Node对象
    this.shapeType = SHAP_TYPE.LINE;  // 图形类别 点还是线
    this.renderData = { // 图形信息表达
      ...this.renderData || {},
      startX, // 起始点x
      startY, // 起始点y
      endX, // 结束点x
      endY, // 结束点y
      size: lineSize, // 当前线长度
      startSize, // 起点的总长度 单线为0 多线拼接为之前所有线的总长
      endSize: startSize + lineSize, // 多线拼接下当前线末尾总长
      direction: getLineDirection(startX, startY, endX, endY), //线方向 ROWLR 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
    };
    
  }

  /**
   * 处理移动后的node操作以及renderData更新
   * @param {*} payload 
   */
  handlerMove({ payload }) {
    const { renderData, stateNode } = this;
    const { x, y } = payload;

    stateNode.move(payload);

    this.renderData = {
      ...renderData,
      startX: fixedNumber(renderData.startX + x),
      startY: fixedNumber(renderData.startY + y),
      endX: fixedNumber(renderData.endX + x),
      endY: fixedNumber(renderData.endY + y),
    }
  }

  /**
 * 处理线挪动以及renderData更新
 * @param {*} payload 
 */
  handlerPoints({ payload }) {
    const { startX, startY, endX, endY } = payload;
    const { stateNode } = this;
    
    stateNode.points([ startX, startY, endX, endY ]);

    this.renderData = getLineRenderData(this, startX, startY, endX, endY)
  }


  // 更新最新的数据 但不做node节点操作
  handlerUpdateRenderData(payload = {}) {
    const { startX, startY, endX, endY } = this.renderData;

    this.renderData = {
      ...getLineRenderData(this, startX, startY, endX, endY),
      ...payload
    }
  }

  // 获取保存的renderData
  getSaveRenderData() {
    const {
      startX,
      startY,
      endX,
      endY,
      size,
      startSize,
      endSize,
      direction
    } = this.renderData

    return {
      sX: startX,
      sY: startY,
      eX: endX,
      eY: endY,
      sz: size,
      ss: startSize,
      es: endSize,
      d: direction
    }
  }
}

export default LineNode;